import { useState } from 'react'

// Picking several things at once (photos, recipes) to do one thing with them all.
export function useSelection() {
  const [selecting, setSelecting] = useState(false)
  const [selected, setSelected] = useState<Set<string>>(new Set())
  return {
    selecting,
    selected,
    start: () => setSelecting(true),
    stop: () => {
      setSelecting(false)
      setSelected(new Set())
    },
    toggle: (id: string) =>
      setSelected((now) => {
        const next = new Set(now)
        if (next.has(id)) next.delete(id)
        else next.add(id)
        return next
      }),
    pickAll: (ids: string[]) => setSelected(new Set(ids)),
  }
}
export type Selection = ReturnType<typeof useSelection>
